import type { IGroupedBarItem } from 'components/Charts/GroupedBar/GroupedBar';
import { GroupedBar } from 'components/Charts/GroupedBar/GroupedBar';
import type { ActKc2UerCostChartData } from 'gql/graphql';

import React, { useMemo } from 'react';

import Style from './AnalyticsUerChart.module.css';

interface IAnalyticsUerChart {
    items?: ActKc2UerCostChartData[] | null;
}

const colors = ['rgb(86, 185, 242)', 'rgb(34, 195, 142)'];

export const AnalyticsUerChart: React.FC<IAnalyticsUerChart> = (props) => {
    const { items } = props;

    const barItems = useMemo(
        () =>
            items?.reduce(
                (acc, item) => [
                    ...acc,
                    {
                        value: item.rimActKC2WorkCost,
                        label: item.uerCode,
                        type: 'Принято в Акте КС-2',
                    },
                    {
                        value: item.skzsActKC2WorkCost,
                        label: item.uerCode,
                        type: 'Согласовано СКзC',
                    },
                ],
                [] as IGroupedBarItem[],
            ) || [],
        [items],
    );

    return (
        <div className={Style.analyticsUerChart}>
            <GroupedBar items={barItems} color={colors} height={400} barWidthWithoutScroll={32} />
        </div>
    );
};

AnalyticsUerChart.displayName = 'AnalyticsUerChart';

export const MemoizedAnalyticsUerChart = React.memo(AnalyticsUerChart);
